export default __webpack_public_path__ + "static/media/lp-sec05_bg1900.152d78b9.png";